export const NOINDEX_ROBOTS_CONTENT = 'noindex,nofollow,noarchive'
export const NOINDEX_HEADER_VALUE = 'noindex, nofollow, noarchive'

const DEFAULT_DOCUMENT_TITLES = new Set(['蒸汽小舖', '蒸汽小铺', '蒸汽小鋪x', 'CHILL-JP', 'AUVAPEMALL', 'Mall Client'])

// Only presentation titles use this alias. CMS content and legal names retain
// their original values, and other storefront templates keep their own brands.
export function resolveSiteDocumentTitle(titleChunk, siteTitle, templateKey = '') {
  const brand = value => {
    const title = String(value || '').trim()
    return templateKey === 'australia' ? title.replace(/\bMistlyAU\b/gi, 'Mistrivo') : title
  }
  const title = brand(titleChunk)
  const site = brand(siteTitle)
  if (!title || DEFAULT_DOCUMENT_TITLES.has(title)) return site
  return site ? title.replace(/蒸汽小[舖铺]|蒸汽小鋪x|CHILL-JP|AUVAPEMALL|Mall Client/g, site) : title
}

export function parseSiteConfigData(configData) {
  if (!configData) {
    return {}
  }

  if (typeof configData === 'string') {
    try {
      return JSON.parse(configData)
    }
    catch (error) {
      console.error('Failed to parse site configData:', error)
      return {}
    }
  }

  if (typeof configData === 'object') {
    return configData
  }

  return {}
}

export function shouldDisableGoogleIndex(input) {
  const configData = input && input.configData !== undefined
    ? parseSiteConfigData(input.configData)
    : parseSiteConfigData(input)

  return Boolean(configData.disableGoogleIndex)
}

export function resolveSiteSeoKeywords(input) {
  const configData = input && input.configData !== undefined
    ? parseSiteConfigData(input.configData)
    : parseSiteConfigData(input)

  return String(configData.seoKeywords || '').trim()
}

export function resolveSiteDisplayTitle(siteInfo, fallback = '') {
  const normalizedSiteInfo = siteInfo && typeof siteInfo === 'object' ? siteInfo : {}
  const configData = parseSiteConfigData(normalizedSiteInfo.configData)

  return String(
    normalizedSiteInfo.title
    || normalizedSiteInfo.pc_SITE_NAME
    || normalizedSiteInfo.mobile_SITE_NAME
    || configData.pc_SITE_NAME
    || configData.mobile_SITE_NAME
    || fallback,
  ).trim()
}

export function resolveSiteDisplayTitleFromSources(sources, fallback = '') {
  const normalizedSources = Array.isArray(sources) ? sources : [sources]

  for (const source of normalizedSources) {
    if (!source || typeof source !== 'object') {
      continue
    }

    const resolvedTitle = resolveSiteDisplayTitle(source)
    if (resolvedTitle) {
      return resolvedTitle
    }

    const configData = parseSiteConfigData(source.configData)
    const extraTitle = String(
      source.jpSiteTitle
      || source.siteTitleJa
      || source.name
      || source.logoText
      || configData.jpSiteTitle
      || configData.siteTitleJa
      || configData.name
      || configData.logoText
      || '',
    ).trim()

    if (extraTitle) {
      return extraTitle
    }
  }

  return String(fallback || '').trim()
}

export function buildSitePageTitle(pageTitle, siteTitle, fallback = '') {
  const normalizedPageTitle = String(pageTitle || '').trim()
  const normalizedSiteTitle = String(siteTitle || '').trim()
  const normalizedFallback = String(fallback || '').trim()

  if (normalizedPageTitle && normalizedSiteTitle && normalizedPageTitle !== normalizedSiteTitle) {
    return `${normalizedPageTitle} - ${normalizedSiteTitle}`
  }

  return normalizedPageTitle || normalizedSiteTitle || normalizedFallback
}

export function buildNoIndexMetaTags() {
  return [
    {
      key: 'robots',
      name: 'robots',
      content: NOINDEX_ROBOTS_CONTENT,
    },
    {
      key: 'googlebot',
      name: 'googlebot',
      content: NOINDEX_ROBOTS_CONTENT,
    },
  ]
}

export function buildSiteKeywordMetaTag(keywords) {
  const normalizedKeywords = String(keywords || '').trim()
  if (!normalizedKeywords) {
    return null
  }

  return {
    key: 'keywords',
    name: 'keywords',
    content: normalizedKeywords,
  }
}

export function buildRobotsTxt(disableGoogleIndex, sitemapUrl = '') {
  if (disableGoogleIndex) {
    return [
      'User-agent: *',
      'Disallow: /',
      '',
      'User-agent: Googlebot',
      'Disallow: /',
      '',
    ].join('\n')
  }

  const lines = [
    'User-agent: *',
    'Allow: /',
  ]

  if (sitemapUrl) {
    lines.push('', `Sitemap: ${sitemapUrl}`)
  }

  lines.push('')

  return lines.join('\n')
}
